/* Wild Ginga: prints shown in a real room.
   1) Collection cards: hover shows the print framed in the room (white wood, A0).
   2) Product page: "See it on the wall" follows the selected Size + Frame, to scale.
   Room photo: Shopify Files "wg-room-portrait.png". The mock-up frame in that photo is
   painted over with a wall patch, then our own frame is drawn on top.
   Remove: delete this file + its script tag in snippets/meta-tags.liquid. */
(function () {
  if (window.__roomHover) return;
  window.__roomHover = true;

  var ROOM = 'https://cdn.shopify.com/s/files/1/0725/2603/7015/files/wg-room-portrait.png?v=1791901710&width=1600';
  var IMG = { w: 1536, h: 1024 };
  var PATCH = { x: 546, y: 0, w: 449, h: 575 };
  var PX_CM = 3.9;            // room scale: image pixels per centimetre on the wall
  var CENTRE = { x: 766, y: 275 }, MAX_BOTTOM = 548, MIN_TOP = 8;
  var BAR_CM = 3.85, MAT_CM = 4;
  /* real oak bars cut from the mock-up photo itself: [x, y, w, h] in image px */
  var OAK = { t: [581, 19, 369, 15], b: [581, 524, 369, 15], l: [566, 34, 15, 490], r: [950, 34, 15, 490] };
  /* White Wood uses Daniel's own white-frame rooms (frame is in the photo; the print goes in the mat window) */
  var WROOM = {
    p: { src: 'https://cdn.shopify.com/s/files/1/0725/2603/7015/files/wg-room-white-portrait.png?v=1791904014&width=1400', w: 1150, h: 1368, frame: [334, 90, 526, 714], minT: 4, maxB: 885,
         bars: { t: [450, 90, 300, 17], b: [450, 787, 300, 17], l: [334, 250, 17, 400], r: [843, 250, 17, 400] } },
    l: { src: 'https://cdn.shopify.com/s/files/1/0725/2603/7015/files/wg-room-white-landscape.png?v=1791904015&width=1400', w: 1491, h: 1055, frame: [630, 129, 671, 395], minT: 4, maxB: 565,
         bars: { t: [800, 129, 300, 17], b: [800, 507, 300, 17], l: [630, 200, 17, 250], r: [1284, 200, 17, 250] } }
  };
  var SIZES = { A2: [42, 59.4], A1: [59.4, 84.1], A0: [84.1, 118.9] };
  var U = {"light": "data:image/jpeg;base64,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", "patch": "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAUDBAQEAwUEBAQFBQUGBwwIBwcHBw8LCwkMEQ8SEhEPERETFhwXExQaFRERGCEYGh0dHx8fExciJCIeJBweHx7/2wBDAQUFBQcGBw4ICA4eFBEUHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh7/wAARCACPAHADASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD0kjHSmnf7VOU+akZK8U9a5X+b0FHz9eKkIxTTQBG2/wBBTfm9BUpppoAZl8cAUmXA7U+kNAETl8dBTPmHYVMaYRRYZGd+ego+f0FPPWkxQIaC3oKCfUc0/BpNvzCkNG2UwaCnFSlfmpdtXYgqSR96gdcVpMmaryxUhlIimmpZEwajIpANpDTsUhoGMYUw1IRTcZoAbilC1IqU8LgUARbaTb81T7abt+agDbI+YUuKdj5qdiqJGYprJkVLilxQIz54apyJg1tMgIqncQe1IozSKQ1NJGVNR4OaQxmKcqU9UqQLimFxgWlxT8UEUWEMxTSPmqTFNI+aiwG2R81KBS4+angVRI0ClxTwtKFosAzbTXjBHSpwtLsosBk3Nv1OKptFg9K3p4/l6Vl3C4NKw7lYLilxTsUlAxtIadSUANpP4qeRTeN3NAjfAy1SLGasiykjmKuOlTCDHaqsTcpiP2p4j9qtiH2pRF7U7BcqiOlCVa8ul8ulYLlGdPlrGuxhjXQ3KYQ1g3wwxoYykaSnUhpWGNopaSiwDabj5qkppHzUWA9FlAaU5prRiny8TGkzVkERjFIUqY80YoAg2UbKmIqKVwoNFgKt5gIa52/+8a1r+46jNYtw240mhplY0lOYU2kMSkpaSgBDSHO6lzSA/NSA7pHl8wrIORU4NDgGU0uKskUUuaSmSOFFMAlkCg1l31z1ANPvLjqM1kXEhYmgRHPIWPWq7HNOY0w0wGMKjNSmo2qWhpjDSUppppWKAmmk/NS03PzUrAejEfvjTsUknEpNIzCrIEdsCqN1LgEVNM/FZ9y1AFS5ckmqUhqxMetVXNADGNMNKxphpgFNNKaaaAGMKYakNMak0O4003+KlNNz81Kwzvhcs+M9RTWl96Qp1wKozlo3znIpkl48jNULo4rQtxHcQYBZWx1FZWpWlzC2fMDLQBUmPNVnNPmVwDk81UYtnk0ASGmE0059aQhsZJouA6mmmEt60jZx1pgONNNMJNHJFACMcUzqaiv7iK1tzLKe+FHqewpNOuoru0iuIsgSoHweoqbq9gP/2Q=="};

  var NOISE = "data:image/svg+xml;utf8," + encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 .5  0 0 0 0 .45  0 0 0 0 .38  0 0 0 .55 0'/></filter><rect width='100%' height='100%' filter='url(#n)'/></svg>");

  var feather = 'linear-gradient(to right,transparent 0,#000 18px,#000 calc(100% - 18px),transparent 100%)';
  var featherV = 'linear-gradient(to bottom,#000 0,#000 calc(100% - 18px),transparent 100%)';

  var css = [
    '.wg-stage{position:absolute;left:0;top:0;width:' + IMG.w + 'px;height:' + IMG.h + 'px;transform-origin:0 0;background:#e9dfd2 url("' + ROOM + '") 0 0/' + IMG.w + 'px ' + IMG.h + 'px no-repeat}',
    '.wg-stage div:empty{display:block}',
    '.wg-patch{position:absolute;left:' + PATCH.x + 'px;top:' + PATCH.y + 'px;width:' + PATCH.w + 'px;height:' + PATCH.h + 'px;background:url("' + U.patch + '") 0 0/100% 100%;',
    '-webkit-mask-image:' + feather + ',' + featherV + ';-webkit-mask-composite:source-in;mask-image:' + feather + ',' + featherV + ';mask-composite:intersect}',
    '.wg-patch:after{content:"";position:absolute;inset:0;background:url("' + NOISE + '");opacity:.22;mix-blend-mode:multiply}',
    '.wg-piece{position:absolute;box-shadow:4px 7px 7px rgba(70,48,25,.30),10px 16px 22px rgba(70,48,25,.16)}',
    '.wg-bar{position:absolute;background-size:100% 100%}',
    '.wg-bar--t{left:0;right:0;top:0;clip-path:polygon(0 0,100% 0,calc(100% - var(--b)) 100%,var(--b) 100%)}',
    '.wg-bar--b{left:0;right:0;bottom:0;clip-path:polygon(var(--b) 0,calc(100% - var(--b)) 0,100% 100%,0 100%)}',
    '.wg-bar--l{top:0;bottom:0;left:0;clip-path:polygon(0 0,100% var(--b),100% calc(100% - var(--b)),0 100%)}',
    '.wg-bar--r{top:0;bottom:0;right:0;clip-path:polygon(0 var(--b),100% 0,100% 100%,0 calc(100% - var(--b)))}',
    '.wg-oak .wg-bar{background-image:url("' + ROOM + '");background-repeat:no-repeat}',
    '.wg-white .wg-bar--t{background:linear-gradient(#fff,#f2f2f0 55%,#d9d8d4)}',
    '.wg-white .wg-bar--b{background:linear-gradient(#f4f3f0,#e4e3df 60%,#cfcdc8)}',
    '.wg-white .wg-bar--l{background:linear-gradient(90deg,#fff,#f1f0ed 55%,#d6d4cf)}',
    '.wg-white .wg-bar--r{background:linear-gradient(90deg,#e9e8e4,#dcdad5 60%,#c8c6c1)}',
    '.wg-black .wg-bar--t{background:linear-gradient(#3a3734,#1d1b19 55%,#121110)}',
    '.wg-black .wg-bar--b{background:linear-gradient(#24221f,#141312 60%,#0c0b0a)}',
    '.wg-black .wg-bar--l{background:linear-gradient(90deg,#34312e,#1b1a18 55%,#111)}',
    '.wg-black .wg-bar--r{background:linear-gradient(90deg,#1e1c1a,#121110 60%,#0a0a09)}',
    '.wg-mat{position:absolute;background:#f8f7f3;box-shadow:inset 2px 3px 4px rgba(0,0,0,.28),inset -1px -1px 1px rgba(0,0,0,.08)}',
    '.wg-art{position:absolute;background-size:cover;background-position:center;box-shadow:0 0 0 1px rgba(0,0,0,.10)}',
    '.wg-plain .wg-art{box-shadow:none}',
    '.wg-perspex .wg-art:after{content:"";position:absolute;inset:0;background:linear-gradient(118deg,rgba(255,255,255,.30) 0%,rgba(255,255,255,.05) 28%,rgba(255,255,255,0) 42%,rgba(255,255,255,0) 72%,rgba(255,255,255,.10) 100%)}',
    '.wg-perspex{box-shadow:6px 10px 10px rgba(70,48,25,.32),14px 22px 28px rgba(70,48,25,.18)}',
    '.wg-metal .wg-art{filter:saturate(.96) contrast(.97)}',
    '.wg-wmode .wg-patch,.wg-wmode .wg-light,.wg-wwin{display:none!important}',
    '.wg-wframe .wg-bar{background-repeat:no-repeat}',
    '.wg-wframe .wg-mat{background:#fbfbfa;box-shadow:inset 1px 2px 3px rgba(0,0,0,.16)}',
    '.wg-wframe{box-shadow:3px 6px 6px rgba(70,48,25,.22),8px 14px 20px rgba(70,48,25,.12)}',
    '.wg-wart{position:absolute;background-size:cover;background-position:center;box-shadow:0 0 0 1px rgba(0,0,0,.18),-1px -1px 0 2px rgba(255,255,255,.9),1px 1px 0 2px rgba(0,0,0,.10)}',
    '.wg-wart:after{content:"";position:absolute;inset:0;box-shadow:inset 1px 2px 3px rgba(0,0,0,.22);background:linear-gradient(120deg,rgba(255,255,255,.10),rgba(255,255,255,0) 40%,rgba(255,250,240,0) 70%,rgba(255,250,240,.06))}',
    '.wg-light{position:absolute;pointer-events:none;mix-blend-mode:soft-light;opacity:.95;background:url("' + U.light + '") no-repeat}',
    /* collection card hover */
    '.room-hover{position:absolute;inset:0;z-index:2;pointer-events:none;opacity:0;overflow:hidden;transition:opacity .2s ease;background:#e9dfd2}',
    '.room-hover-ready:hover .room-hover,.room-hover-ready:focus-within .room-hover{opacity:1}',
    '.room-hover-ready .stock-hover{flex-direction:row;flex-wrap:wrap;justify-content:center;align-items:center;gap:.2rem 1.4rem;padding:.5rem .8rem;font-size:1.15rem;background:rgba(30,24,18,.62)}',
    '.room-hover-ready .stock-hover__title{display:none}',
    '.room-hover-ready .stock-hover__row{gap:.5rem}',
    '@media (hover:none){.room-hover{display:none}}',
    /* product page panel */
    '.wall-preview{margin:2rem 0;width:100%}',
    '.product__media-wrapper:has(.wall-preview) .product__column-sticky{position:static!important;top:auto!important}',
    '.wall-preview__label{font-size:1.3rem;letter-spacing:.1rem;text-transform:uppercase;opacity:.75;margin:0 0 .8rem}',
    '.wall-preview__scene{position:relative;width:100%;aspect-ratio:3/2;overflow:hidden;background:#e9dfd2}',
    '.wall-preview__cap{font-size:1.3rem;margin:.8rem 0 0;opacity:.8;line-height:1.5}'
  ].join('');
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);
  [ROOM, WROOM.p.src].forEach(function (u) { (new Image()).src = u; }); // warm the cache so the first hover is instant

  function frameKind(name) {
    var n = String(name || '').toLowerCase();
    if (n.indexOf('perspex') > -1) return { cls: 'wg-perspex wg-plain', wood: false };
    if (n.indexOf('metal') > -1) return { cls: 'wg-metal wg-plain', wood: false };
    if (n.indexOf('brown') > -1) return { cls: 'wg-oak', wood: true };
    if (n.indexOf('white') > -1) return { cls: 'wg-white', wood: true };
    if (n.indexOf('black') > -1) return { cls: 'wg-black', wood: true };
    return { cls: 'wg-none wg-plain', wood: false };
  }

  function bestSrc(img) {
    var set = img.getAttribute('srcset');
    if (set) {
      var best = null, bestW = 0;
      set.split(',').forEach(function (p) {
        var bits = p.trim().split(/\s+/), w = parseInt(bits[1], 10) || 0;
        if (w >= bestW && w <= 1500) { best = bits[0]; bestW = w; }
      });
      if (best) return best;
    }
    return img.currentSrc || img.src;
  }

  function buildStage() {
    var st = document.createElement('div');
    st.className = 'wg-stage';
    st.innerHTML = '<div class="wg-patch"></div><div class="wg-piece"><div class="wg-bar wg-bar--t"></div><div class="wg-bar wg-bar--b"></div>' +
      '<div class="wg-bar wg-bar--l"></div><div class="wg-bar wg-bar--r"></div><div class="wg-mat"></div><div class="wg-art"></div></div><div class="wg-light"></div><div class="wg-wwin"><div class="wg-wart"></div></div>';
    return st;
  }

  function setArt(st, src) {
    var a = st.querySelector('.wg-art'), b = st.querySelector('.wg-wart');
    if (a.dataset.src === src) return;
    a.dataset.src = src;
    a.style.backgroundImage = b.style.backgroundImage = 'url("' + src + '")';
  }

  function stageRoom(st, room) {
    var key = room ? room.src : 'oak';
    if (st.dataset.room === key) return;
    st.dataset.room = key;
    st.classList.toggle('wg-wmode', !!room);
    st._w = room ? room.w : IMG.w; st._h = room ? room.h : IMG.h;
    st.style.width = st._w + 'px'; st.style.height = st._h + 'px';
    st.style.background = room ? '#e9dfd2 url("' + room.src + '") 0 0/' + room.w + 'px ' + room.h + 'px no-repeat' : '';
  }

  /* lay the piece out on the wall in image pixels */
  function placePiece(st, ratio, sizeKey, frameName) {
    var dims = SIZES[sizeKey] || SIZES.A0, kind = frameKind(frameName);
    stageRoom(st, null);
    var longCm = dims[1];
    var aw = (ratio >= 1 ? longCm : longCm * ratio) * PX_CM, ah = (ratio >= 1 ? longCm / ratio : longCm) * PX_CM;
    var b = kind.wood ? BAR_CM * PX_CM : 0, m = kind.wood ? MAT_CM * PX_CM : 0;
    var w = aw + 2 * (b + m), h = ah + 2 * (b + m);
    var left = CENTRE.x - w / 2, top = CENTRE.y - h / 2;
    if (top + h > MAX_BOTTOM) top = MAX_BOTTOM - h;
    if (top < MIN_TOP) top = MIN_TOP;
    var piece = st.querySelector('.wg-piece');
    piece.className = 'wg-piece ' + kind.cls;
    piece.style.cssText = 'left:' + left + 'px;top:' + top + 'px;width:' + w + 'px;height:' + h + 'px;--b:' + b + 'px';
    st.querySelectorAll('.wg-bar').forEach(function (bar) {
      var side = bar.className.match(/wg-bar--(\w)/)[1], horiz = side === 't' || side === 'b';
      var bw = horiz ? w : b, bh = horiz ? b : h;
      var cs = 'display:' + (kind.wood ? 'block' : 'none') + ';' + (horiz ? 'height:' + b + 'px' : 'width:' + b + 'px');
      if (kind.cls === 'wg-oak') {
        var c = OAK[side], sx = bw / c[2], sy = bh / c[3];
        cs += ';background-size:' + (IMG.w * sx) + 'px ' + (IMG.h * sy) + 'px;background-position:' + (-c[0] * sx) + 'px ' + (-c[1] * sy) + 'px';
      } else if (kind.cls === 'wg-white') {
        /* real white moulding cut from Daniel's white-frame photo */
        var R = WROOM.p, d = R.bars[side], ex = bw / d[2], ey = bh / d[3];
        cs += ';background:url("' + R.src + '") no-repeat;background-size:' + (R.w * ex) + 'px ' + (R.h * ey) + 'px;background-position:' + (-d[0] * ex) + 'px ' + (-d[1] * ey) + 'px';
      }
      bar.style.cssText = cs;
    });
    var mat = st.querySelector('.wg-mat');
    mat.style.cssText = 'display:' + (kind.wood ? 'block' : 'none') + ';left:' + b + 'px;top:' + b + 'px;right:' + b + 'px;bottom:' + b + 'px';
    var art = st.querySelector('.wg-art');
    art.style.left = art.style.top = (b + m) + 'px';
    art.style.width = aw + 'px'; art.style.height = ah + 'px';
    var light = st.querySelector('.wg-light');
    light.style.cssText = 'left:' + left + 'px;top:' + top + 'px;width:' + w + 'px;height:' + h + 'px;background-size:' + IMG.w + 'px ' + IMG.h + 'px;background-position:' + (-left) + 'px ' + (-top) + 'px';
    return { left: left, top: top, w: w, h: h, artW: aw / PX_CM, artH: ah / PX_CM };
  }

  /* scale + crop the 1536x1024 stage into a container */
  function fit(st, W, H, focus, minVisibleW) {
    var iw = st._w || IMG.w, ih = st._h || IMG.h;
    var s = Math.max(W / minVisibleW, H / ih);
    if (W / s > iw) s = W / iw;
    var vw = W / s, vh = H / s;
    var tx = Math.min(Math.max(focus.x - vw / 2, 0), iw - vw);
    var ty = Math.min(Math.max(focus.y - vh / 2, 0), ih - vh);
    st.style.transform = 'scale(' + s + ') translate(' + (-tx) + 'px,' + (-ty) + 'px)';
  }

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var printCache = {};
  function isPrint(handle) {
    if (!printCache[handle]) {
      printCache[handle] = fetch(root + 'products/' + handle + '?view=stock-json', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (t) { var d = t ? JSON.parse(t) : null; return !!(d && d.sizes && d.sizes.length); })
        .catch(function () { return false; });
    }
    return printCache[handle];
  }

  /* ---------- 1) collection card hover ---------- */
  var primer = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      primer.unobserve(e.target);
      e.target.dispatchEvent(new Event('mouseenter'));
    });
  }, { rootMargin: '400px 0px' }) : null;

  function attachCard(card) {
    if (card.dataset.roomHover) return;
    card.dataset.roomHover = '1';
    var link = card.querySelector('a[href*="/products/"]');
    var img = card.querySelector('.card__media img');
    if (!link || !img) return;
    var mm = link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    if (!mm) return;
    var handle = mm[1];
    var host = card.querySelector('.card__inner') || card;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var built = null, checked = false;

    function layout() {
      var W = host.clientWidth, H = host.clientHeight;
      if (!W || !H) return;
      var p = placePiece(built.stage, built.ratio, 'A0', 'White Wood');
      var k = p.white ? 1.4 : 1.9, dy = p.white ? p.h * 0.12 : 70;
      fit(built.stage, W, H, { x: p.left + p.w / 2, y: p.top + p.h / 2 + dy }, Math.max(p.w, p.h * W / H) * k);
    }
    function build() {
      var w = parseFloat(img.getAttribute('width')) || img.naturalWidth;
      var h = parseFloat(img.getAttribute('height')) || img.naturalHeight;
      if (!w || !h) return;
      var wrap = document.createElement('div');
      wrap.className = 'room-hover';
      wrap.setAttribute('aria-hidden', 'true');
      var st = buildStage();
      wrap.appendChild(st);
      host.appendChild(wrap);
      setArt(st, img.currentSrc || img.src);
      built = { ratio: w / h, stage: st };
      layout();
      card.classList.add('room-hover-ready');
    }
    function enter() {
      if (built) { layout(); return; }
      if (checked) return;
      checked = true;
      isPrint(handle).then(function (ok) { if (ok) build(); });
    }
    card.addEventListener('mouseenter', enter);
    card.addEventListener('focusin', enter);
    if (primer) primer.observe(card); else enter();
  }

  /* ---------- 2) product page wall preview ---------- */
  function readOptions() {
    var o = {};
    document.querySelectorAll('variant-selects fieldset').forEach(function (fs) {
      var l = fs.querySelector('legend'), c = fs.querySelector('input:checked');
      if (l && c) o[l.textContent.trim().toLowerCase()] = c.value;
    });
    document.querySelectorAll('variant-selects .product-form__input--dropdown').forEach(function (d) {
      var l = d.querySelector('label'), s = d.querySelector('select');
      if (l && s) o[l.textContent.trim().toLowerCase()] = s.value;
    });
    return o;
  }

  var pageImg = null;
  function productImage() {
    if (pageImg) return pageImg;
    var img = document.querySelector('.product__media img');
    if (!img) return null;
    var w = parseFloat(img.getAttribute('width')) || img.naturalWidth;
    var h = parseFloat(img.getAttribute('height')) || img.naturalHeight;
    if (!w || !h) return null;
    pageImg = { src: bestSrc(img), ratio: w / h };
    return pageImg;
  }

  function renderProduct(panel) {
    var opts = readOptions();
    var size = (opts.size || '').toUpperCase();
    var pic = productImage();
    if (!SIZES[size] || !pic) { panel.style.display = 'none'; return; }
    panel.style.display = '';
    var scene = panel.querySelector('.wall-preview__scene');
    var st = scene.querySelector('.wg-stage');
    var art = st.querySelector('.wg-art');
    setArt(st, pic.src);
    var p = placePiece(st, pic.ratio, size, opts.frame);
    var W = scene.clientWidth, H = scene.clientHeight;
    if (W && H) {
      if (p.white) fit(st, W, H, { x: p.left + p.w / 2, y: p.top + p.h / 2 }, st._w);
      else fit(st, W, H, { x: CENTRE.x, y: 380 }, 1240);
    }
    var cap = panel.querySelector('.wall-preview__cap');
    var txt = size + ' · ' + (opts.frame || 'No Frame') + ' — print approx. ' + Math.round(p.artW) + ' × ' + Math.round(p.artH) + ' cm.' + (p.white ? ' Styled room view.' : ' Shown to scale above a 3 m sofa.');
    if (cap.textContent !== txt) cap.textContent = txt;
  }

  var panelRef = null, pending = false;
  function ensureProductPanel() {
    if (!/\/products\//.test(location.pathname)) return;
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    var hasSize = Array.prototype.some.call(vs.querySelectorAll('legend, label'), function (l) {
      return l.textContent.trim().toLowerCase() === 'size';
    });
    if (!hasSize) return;
    if (!panelRef || !document.body.contains(panelRef)) {
      panelRef = document.createElement('div');
      panelRef.className = 'wall-preview';
      panelRef.innerHTML = '<p class="wall-preview__label">See it on the wall</p><div class="wall-preview__scene"></div><p class="wall-preview__cap"></p>';
      panelRef.querySelector('.wall-preview__scene').appendChild(buildStage());
      var gallery = document.querySelector('.product__media-wrapper media-gallery') || document.querySelector('media-gallery');
      if (gallery) { gallery.parentNode.insertBefore(panelRef, gallery.nextSibling); gallery.style.position = 'static'; }
      else vs.parentNode.insertBefore(panelRef, vs.nextSibling);
    }
    renderProduct(panelRef);
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; ensureProductPanel(); });
  }

  /* ---------- boot ---------- */
  function scanCards() { document.querySelectorAll('.card-wrapper').forEach(attachCard); }
  function init() {
    scanCards();
    ensureProductPanel();
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects')) setTimeout(schedule, 0);
    });
    window.addEventListener('resize', schedule);
    new MutationObserver(function () { scanCards(); schedule(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
